'use client';

import { ReactNode, useState, useEffect } from 'react';
import { useMobileNav } from '@/components/patterns/hooks/use-mobile-nav';

interface MobileNavWrapperProps {
  children: ReactNode;
}

export default function MobileNavWrapper({ children }: MobileNavWrapperProps) {
  const [isHydrated, setIsHydrated] = useState(false);
  const { showMobileNav } = useMobileNav({ isAuthenticated: false, userType: null });

  // ✅ Fix hydration mismatch by waiting for client-side hydration
  useEffect(() => {
    setIsHydrated(true);
  }, []);

  // During SSR and before hydration, don't apply mobile nav styles to avoid mismatch
  const shouldApplyMobileNavStyles = isHydrated && showMobileNav;

  return (
    <div className={`min-h-[100vh] min-h-[100dvh] flex flex-col ${
      shouldApplyMobileNavStyles
        ? 'pb-[calc(env(safe-area-inset-bottom)+var(--mobile-nav-height)+var(--mobile-nav-padding))] md:pb-0' 
        : ''
    }`}>
      {children}
    </div>
  );
} 